import { setClickContext } from '../../../components/ClickToBuy/clickContext';
export const CLICK_TO_BUY_CONTEXT_TYPE = 'clickToBuy';
const isClickToBuyWrapper = elem => { var _a; return ((_a = elem.dataset) === null || _a === void 0 ? void 0 : _a.testid) === 'click-to-buy-component'; };
const makeClickToBuyContext = elem => {
    var _a, _b;
    return ({
        type: CLICK_TO_BUY_CONTEXT_TYPE,
        aemPromotion: {
            type: elem.dataset.analyticsCreative,
            name: (_b = (_a = elem.querySelector('[data-testid="trading-cell"]')) === null || _a === void 0 ? void 0 : _a.dataset) === null || _b === void 0 ? void 0 : _b.analyticsName,
        },
    });
};
export function setClickToBuyContext(e) {
    if (isClickToBuyWrapper(e.currentTarget))
        setClickContext(makeClickToBuyContext(e.currentTarget), e);
}
//# sourceMappingURL=clickToBuyContext.js.map